import superagentPromise from 'superagent-promise';
import _superagent from 'superagent';
import userStore from './mobx-stores/userStore';
import constants from './constants';

const superagent = superagentPromise(_superagent, global.Promise);

const API_ROOT = constants.API_ROOT;

const encode = encodeURIComponent;

const handleErrors = (err, res) => {

  if (err && err.response && err.response.status === 401) {
    console.log(err)
    if (res && res.body && res.body.type && res.body.type === 'INVALID_OTP')
      return
    else
      userStore.goToLogin();
  }
  return err;
};

const handleChatErrors = (err, res) => {

  if (err && err.response && err.response.status === 401) {
    return '401'
  }
  //return err;
};

const errorHandler = (err, res) => {
  if (err && err.response && err.response.status === 401) {
    if (res && res.body && res.body.type && res.body.type === 'INVALID_OTP')
      return
    else
      userStore.goToLogin();
  }
  let error = {
    error: err,
    response: res
  }
  return error;
};

const responseBody = res => res.body;
const responseFull = res => res;

const tokenPlugin = req => {
  if (userStore.token) {
    req.set('Authorization', `Bearer ${userStore.token}`);
  }
};

const requestsReports = {
  get: url =>
    superagent
      .get(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody),
  post: (url, body) =>
    superagent
      .post(`${API_ROOT}${url}`, body)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody),
};

const requests = {
  del: url =>
    superagent
      .del(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody),
  get: url =>
    superagent
      .get(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody),
  getChat: url =>
    superagent
      .get(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .end(handleChatErrors)
      .then(responseBody),
  getFull: url =>
    superagent
      .get(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseFull),
  put: (url, body) =>
    superagent
      .put(`${API_ROOT}${url}`, body)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody),
  post: (url, body) =>
    superagent
      .post(`${API_ROOT}${url}`, body)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody),
  postHomePage: (url, body) =>
    superagent
      .post(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .end(handleChatErrors)
      .then(responseBody),

  postDocument: (url, tempId, stepNumber, imageFront) =>
    superagent
      .post(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .field('tempId', JSON.stringify(tempId))
      .field('stepNumber', JSON.stringify(stepNumber))
      .accept('application/json')
      .attach('imageFront', imageFront)
      .end(handleErrors)
      .then(responseBody),
  postDocuments: (url, tempId, stepNumber, imageFront, imageBack) =>
    superagent
      .post(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .field('tempId', JSON.stringify(tempId))
      .field('stepNumber', JSON.stringify(stepNumber))
      .accept('application/json')
      .attach('imageFront', imageFront)
      .attach('imageBack', imageBack)
      .end(handleErrors)
      .then(responseBody),

  postAttachments: (url, files, messageBy, sessionId, messageText) =>
    superagent
      .post(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .accept('application/json')
      .attach('messageAttachment', files[0])
      .attach('messageAttachment', files[1])
      .attach('messageAttachment', files[2])
      .attach('messageAttachment', files[3])
      .attach('messageAttachment', files[4])
      .attach('messageAttachment', files[5])
      .attach('messageAttachment', files[6])
      .attach('messageAttachment', files[7])
      .attach('messageAttachment', files[8])
      .attach('messageAttachment', files[9])
      .attach('messageAttachment', files[10])
      .field('messageText', messageText)
      .field('messageBy', messageBy)
      .field('sessionId', sessionId)
      .end(handleErrors)
      .then(responseBody),
  postAttachmentsWithoutCom: (url, files, messageBy, sessionId) =>
    superagent
      .post(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .accept('application/json')
      .attach('messageAttachment', files[0])
      .attach('messageAttachment', files[1])
      .attach('messageAttachment', files[2])
      .attach('messageAttachment', files[3])
      .attach('messageAttachment', files[4])
      .attach('messageAttachment', files[5])
      .attach('messageAttachment', files[6])
      .attach('messageAttachment', files[7])
      .attach('messageAttachment', files[8])
      .attach('messageAttachment', files[9])
      .attach('messageAttachment', files[10])
      .field('messageBy', messageBy)
      .field('sessionId', sessionId)
      .end(handleErrors)
      .then(responseBody),
  ticketReply: (url, files, message, tempId) =>
    superagent
      .post(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .accept('application/json')
      .attach('files', files[0])
      .attach('files', files[1])
      .attach('files', files[2])
      .attach('files', files[3])
      .attach('files', files[4])
      .attach('files', files[5])
      .attach('files', files[6])
      .attach('files', files[7])
      .attach('files', files[8])
      .attach('files', files[9])
      .attach('files', files[10])
      .field('message', message)
      .field('tempId', tempId)
      .end(handleErrors)
      .then(responseBody),
  ticketReplyWithoutCom: (url, files, tempId) =>
    superagent
      .post(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .accept('application/json')
      .attach('files', files[0])
      .attach('files', files[1])
      .attach('files', files[2])
      .attach('files', files[3])
      .attach('files', files[4])
      .attach('files', files[5])
      .attach('files', files[6])
      .attach('files', files[7])
      .attach('files', files[8])
      .attach('files', files[9])
      .attach('files', files[10])
      .field('tempId', tempId)
      .end(handleErrors)
      .then(responseBody),

};

const Auth = {
  getOtp: (mobileNo) =>
    requests.post('customer/sendOTP', { mobileNo: mobileNo }),
  verifyOTP: (mobileNo, otp) =>
    requests.post('customer/verifyOTP', { mobileNo: mobileNo, OTP: otp }),
  getStatusCount: () =>
    requests.get(`customer/statusCount`),
};

const Home = {
  getFaqs: (tempId) => {
    if (userStore.authenticated) {
      return requests.get(`getHomePageData` +
        (tempId !== undefined ? `?tempId=${tempId}` : '')
      )
    }
    else if (userStore.token) {
      return requests.postHomePage(`getHomePageDataAnonymous`)
    }
    else {
      return requests.get(`getHomePageDataAnonymous`)
    }
  }
  ,
  getAutoSuggestText: (text) => {
    if (userStore.authenticated)
      return requests.get(`autoSuggest/${encodeURIComponent(text)}`)
    else
      return requests.get(`autoSuggestAnonymous/${encodeURIComponent(text)}`)
  }
}

const Query = {
  askQueries: (filteredIntentsArray, searchText, policyNo, actionType) => {
    if (userStore.authenticated)
      return requests.post(`query/search/${searchText}`, { filteredIntentsArray, policyNo })
    else
      return requests.post(`query/searchAnonymous/${searchText}`, { filteredIntentsArray, policyNo })
  }
  ,
  updateQuery: (filteredIntentsArray, searchText, tempId, policyNo) =>
    requests.post(`query/update/${searchText}`, { filteredIntentsArray, tempId, policyNo }),
  getQueries: (type, pageNo) => {
    if (type === 'pending')
      return requests.get(`query/getPendingQuery?pageNo=${pageNo}`)
    else
      return requests.get(`query/getCompletedQuery?pageNo=${pageNo}`)
  },
  downloadPolicy: (fileName) =>
    requests.get(`policy/download/${fileName}`),
  uploadDocuments: (tempId, stepNumber, imageFront, imageBack) => {
    if (imageBack && imageBack.name !== undefined)
      return requests.postDocuments(`uploadDocument`, tempId, stepNumber, imageFront, imageBack)
    else
      return requests.postDocument(`uploadDocument`, tempId, stepNumber, imageFront)
  },
  getQueryLog: (tempId) =>
    requests.get(`query/getQueryLog?tempId=${tempId}`),
  respondToTicket: (files, message, tempId) => {
    if (message !== undefined)
      return requests.ticketReply(`customer/queryResponse`, files, message, tempId)
    else
      return requests.ticketReplyWithoutCom(`customer/queryResponse`, files, tempId)
  },
}

const Feedback = {
  sendFeedback: (feedbackType, tempId, feedbackText, stars) =>
    requests.post(`${feedbackType}Response`, { tempId, feedbackText, stars })
}

const Chat = {
  initiateChat: (intent, queryText) => {
    if (userStore.authenticated)
      return requests.post(`chat/initiate`, { initiatedVia: 'WEB', intent, queryText })
    else
      return requests.post(`chat/initiateChatAnonymous`, { initiatedVia: 'WEB', intent, queryText })
  },
  reply: (messageText, files, messageBy, sessionId) => {
    if (messageText == undefined)
      return requests.postAttachmentsWithoutCom(userStore.authenticated ? `chat/sendMsgCustomer` : 'chat/sendMsgAnonymous', files, messageBy, sessionId)
    else
      return requests.postAttachments(userStore.authenticated ? `chat/sendMsgCustomer` : 'chat/sendMsgAnonymous', files, messageBy, sessionId, messageText)
  },
  getAllMessages: (sessionId, pageNo, skip, direction) => {
    if (userStore.authenticated)
      return requests.getChat(`chat/getAllMsgCustomer?sessionId=${sessionId}&limit=20&skip=${skip}&direction=${direction}`)
    else
      return requests.getChat(`chat/getAllMsgAnonymous?sessionId=${sessionId}&limit=20&skip=${skip}&direction=${direction}`)
  },
  getChatList: (pageNo) => {
    return requests.get(`chat/getCustomerChatList?pageNo=${pageNo}&limit=15`)
  },
  indicateTyping: (sessionId) => {
    if (userStore.authenticated)
      return requests.post(`chat/indicateTypingCustomer`, { typingBy: 'CUSTOMER', sessionId })
    else
      return requests.post(`chat/indicateTypingAnonymous`, { typingBy: 'CUSTOMER', sessionId })
  }

}

//allStepsData.step_2.apiURL


export default {
  Auth,
  Home,
  Query,
  Feedback,
  Chat
};
